import { CapexDataApiResponse } from './capex.types'
import { CapexData } from '@modules/capex/domain/capex.types'

export const formatCapexData = (payload: CapexDataApiResponse): CapexData => {
  return {
    configId: payload.capexConfigurationId,
    family: payload.family,
    createdDate: payload.createdAt,
    startDate: payload.startDate,
  }
}

export const formatCapexDataList = (
  payload: CapexDataApiResponse[]
): CapexData[] => {
  return payload.map(formatCapexData)
}
